export default __webpack_public_path__ + "static/media/insta.5fd28c99.png";